import { useMutation } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import React from 'react';
import AsyncSelect from 'react-select/async';
import { authHeaders } from '../../actions';
import Routes from '../../utils/routes.js.erb';

const ProgramContentSelector = React.memo(({
  value,
  onChange,
  isDisabled,
  onErrorMessage,
  className = '',
  placeholder = 'Start typing to search for Tips',
}) => {
  const searchTimeoutRef = React.useRef(null);

  const loadOptions = (inputValue, callback) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (!inputValue.trim()) {
      callback([]);
      return;
    }

    searchTimeoutRef.current = setTimeout(() => {
      mutation.mutate(inputValue, {
        onSuccess: (data) => {
          callback(data);
        },
        onError: (error) => {
          onErrorMessage('Oops! Something went wrong. Contact support for help.');
          console.error('Error fetching program content entries:', error);
          callback([]);
        }
      });
    }, 500);
  };

  const mutation = useMutation({
    mutationFn: async (searchQuery) => {
      const response = await fetch(
        Routes.api_dashboard_communication_filters_for_pc_path({ q: searchQuery }),
        {
          method: 'GET',
          headers: authHeaders()
        }
      );

      if (!response.ok) {
        throw new Error('Error fetching program content entries');
      }

      return response.json();
    }
  });

  return(
    <AsyncSelect
      name='sp-pc-select'
      className={`o-communication__select ${className}`}
      isMulti={true}
      value={value}
      loadOptions={loadOptions}
      placeholder={placeholder}
      onChange={onChange}
      isDisabled={isDisabled}
      cacheOptions={true}
      defaultOptions={false}
      menuPlacement="top"
    />
  )
});

ProgramContentSelector.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  onErrorMessage: PropTypes.func.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
}

export default ProgramContentSelector;
